

export const SingleSIFFList = ( props: any) => {

  const { email, bookingCount, combinedInfo } = props;
  const totalSum = combinedInfo.reduce((sum:any, obj:any) => sum + Number(obj.cart_information.original_price), 0);
  return (
    <tr>
      <td>{email}</td>
      <td>{bookingCount}</td>
      <td>{totalSum.toString()}</td>
    </tr>
  );
};

